import { gql } from "@apollo/client";

export const SEARCH_ITEM_FIELDS = gql`
  fragment SEARCH_ITEM_FIELDS on Item {
    id
    name
    brand
    retailer
    price
    originalPrice
    thumbnailImage
    seoURL
    saved
    newIn
  }
`;
